<template>
  <div class="dashboard-container">
    <div class="row-container">
      <div class="section-wrapper half-width">
        <div class="section-title-row">
          <span class="section-title">数据概况</span>
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            class="date-picker"
            @change="loadOverview"
          />
        </div>
        
        <div class="stats-cards-container">
          <div class="stats-card">
            <div class="card-content">
              <div class="card-icon" style="background-color: #409EFF;">
                <i class="el-icon-document"></i>
              </div>
              <div class="card-info">
                <div class="card-title">租赁订单数</div>
                <div class="card-value">{{ dataOverview.rentOrderCount }}</div>
              </div>
            </div>
          </div>
          
          <div class="stats-card">
            <div class="card-content">
              <div class="card-icon" style="background-color: #67C23A;">
                <i class="el-icon-circle-check"></i>
              </div>
              <div class="card-info">
                <div class="card-title">租赁订单完成数</div>
                <div class="card-value">{{ dataOverview.rentOrderCompleteCount }}</div>
              </div>
            </div>
          </div>
          
          <div class="stats-card">
            <div class="card-content">
              <div class="card-icon" style="background-color: #E6A23C;">
                <i class="el-icon-wallet"></i>
              </div>
              <div class="card-info">
                <div class="card-title">实收金额(元)</div>
                <div class="card-value">{{ dataOverview.realIncomeAmount }}</div>
              </div>
            </div>
          </div>
          
          <div class="stats-card">
            <div class="card-content">
              <div class="card-icon" style="background-color: #909399;">
                <i class="el-icon-user"></i>
              </div>
              <div class="card-info">
                <div class="card-title">用车用户数</div>
                <div class="card-value">{{ dataOverview.userCount }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="section-wrapper half-width">
        <div class="section-title-row">
          <span class="section-title">实时车辆数</span>
        </div>
        
        <div class="stats-cards-container">
          <div class="stats-card">
            <div class="card-content">
              <div class="card-icon" style="background-color: #409EFF;">
                <i class="el-icon-bicycle"></i>
              </div>
              <div class="card-info">
                <div class="card-title">马蹄锁车数</div>
                <div class="card-value">{{ vehicleStats.matiCount }}</div>
              </div>
            </div>
          </div>
          
          <div class="stats-card">
            <div class="card-content">
              <div class="card-icon" style="background-color: #67C23A;">
                <i class="el-icon-bicycle"></i>
              </div>
              <div class="card-info">
                <div class="card-title">中控器车数</div>
                <div class="card-value">{{ vehicleStats.zhongkongCount }}</div>
              </div>
            </div>
          </div>
          
          <div class="stats-card">
            <div class="card-content">
              <div class="card-icon" style="background-color: #E6A23C;">
                <i class="el-icon-bicycle"></i>
              </div>
              <div class="card-info">
                <div class="card-title">涨闸锁车数</div>
                <div class="card-value">{{ vehicleStats.brakeCount }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="section-wrapper chart-section">
      <div class="section-title-row">
        <span class="section-title">租赁订单收入趋势</span>
        <el-date-picker
          v-model="chartDateRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          class="date-picker"
          @change="onChartDateChange"
        />
        <div class="chart-buttons">
          <el-button size="small" :type="chartType === 'bar' ? 'primary' : 'default'" @click="changeChartType('bar')">柱状图</el-button>
          <el-button size="small" :type="chartType === 'line' ? 'primary' : 'default'" @click="changeChartType('line')">折线图</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button size="small" :type="activeChartRange === 7 ? 'primary' : 'default'" @click="setChartRange(7)">近7天</el-button>
          <el-button size="small" :type="activeChartRange === 30 ? 'primary' : 'default'" @click="setChartRange(30)">近30天</el-button>
        </div>
      </div>
      
      <div class="chart-container">
        <div id="orderChart" ref="orderChart" style="width: 100%; height: 400px;"></div>
      </div>
    </div>
    
    <div class="action-container">
      <el-button type="primary" size="medium" @click="refreshAll" class="refresh-btn">
        <i class="el-icon-refresh"></i> 刷新数据
      </el-button>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { getCurrentDistributorId } from '@/utils/distributor.js'

export default {
  data() {
    return {
      dateRange: [],
      chartDateRange: [],
      dataOverview: {
        rentOrderCount: 0,
        rentOrderCompleteCount: 0,
        realIncomeAmount: '0.00',
        refundAmount: '0.00',
        userCount: 0
      },
      vehicleStats: {
        matiCount: 0,
        zhongkongCount: 0,
        brakeCount: 0,
        paopaoCount: 0
      },
      orderChart: null,
      chartData: {
        dates: [],
        orderCounts: [],
        orderAmounts: []
      },
      activeChartRange: 30,
      chartType: 'line',
      queryDistributorId: '',
      _resizeHandler: null,
      isAdmin: false,
      distributorRankList: [],
      rankLoading: false,
      rankMaxCount: 1,
      rankDate: ''
    }
  },

  created() {
    this.isAdmin = window.sessionStorage.getItem('isAdmin') === 'true'
    this.queryDistributorId = getCurrentDistributorId()
    this.initDateRange()
    this.initRankDate()
    this.loadOverview()
    this.loadVehicleStats()
    if (this.isAdmin) {
      this.loadDistributorRank()
    }
    this.$root.$on('distributorChanged', this.handleDistributorChange)
  },
  
  mounted() {
    this.$nextTick(() => {
      this.initOrderChart()
      this.loadChartData()
    })
  },
  
  beforeDestroy() {
    this.$root.$off('distributorChanged', this.handleDistributorChange)
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler)
      this._resizeHandler = null
    }
    if (this.orderChart) {
      this.orderChart.dispose()
      this.orderChart = null
    }
  },
  
  methods: {
    handleDistributorChange(distributorId) {
      this.queryDistributorId = distributorId || ''
      this.loadOverview()
      this.loadVehicleStats()
      this.loadChartData()
      if (this.isAdmin) {
        this.loadDistributorRank()
      }
    },
    initDateRange() {
      const today = dayjs()
      const startDate = today.startOf('day')
      const endDate = today.endOf('day')
      this.dateRange = [startDate.format('YYYY-MM-DD HH:mm:ss'), endDate.format('YYYY-MM-DD HH:mm:ss')]
      
      const chartStartDate = today.subtract(30, 'day').startOf('day')
      const chartEndDate = today.endOf('day')
      this.chartDateRange = [chartStartDate.format('YYYY-MM-DD HH:mm:ss'), chartEndDate.format('YYYY-MM-DD HH:mm:ss')]
    },
    
    setChartRange(days) {
      this.activeChartRange = days
      const today = dayjs()
      const startDate = today.subtract(days, 'day').startOf('day')
      const endDate = today.endOf('day')
      this.chartDateRange = [startDate.format('YYYY-MM-DD HH:mm:ss'), endDate.format('YYYY-MM-DD HH:mm:ss')]
      this.loadChartData()
    },
    
    onChartDateChange() {
      this.activeChartRange = null
      this.loadChartData()
    },
    
    changeChartType(type) {
      this.chartType = type
      this.updateChartOption()
    },
    
    loadOverview() {
      this.$http.get('/dashboard/overview', {
        params: {
          startTime: this.dateRange[0],
          endTime: this.dateRange[1],
          queryDistributorId: this.queryDistributorId
        }
      }).then((res) => {
        if (res.data.code == 200) {
          this.dataOverview = res.data.data
        }
      })
    },
    
    loadVehicleStats() {
      this.$http.get('/dashboard/vehicle-stats', {
        params: {
          queryDistributorId: this.queryDistributorId
        }
      }).then((res) => {
        if (res.data.code == 200) {
          this.vehicleStats = res.data.data
        }
      })
    },
    
    loadChartData() {
      this.$http.get('/dashboard/order-trend', {
        params: {
          startTime: this.chartDateRange[0],
          endTime: this.chartDateRange[1],
          queryDistributorId: this.queryDistributorId
        }
      }).then((res) => {
        if (res.data.code == 200) {
          this.chartData = res.data.data
          this.updateChartOption()
        }
      })
    },
    
    refreshAll() {
      this.loadOverview()
      this.loadVehicleStats()
      this.loadChartData()
      if (this.isAdmin) {
        this.loadDistributorRank()
      }
    },
    
    initOrderChart() {
      const chartDom = this.$refs.orderChart
      if (!chartDom) return
      
      if (this.orderChart) {
        this.orderChart.dispose()
      }
      
      this.orderChart = this.$echarts.init(chartDom)
      
      if (!this._resizeHandler) {
        this._resizeHandler = () => {
          if (this.orderChart) {
            this.orderChart.resize()
          }
        }
        window.addEventListener('resize', this._resizeHandler)
      }
      
      this.updateChartOption()
    },
    
    updateChartOption() {
      if (!this.orderChart) {
        this.initOrderChart()
        return
      }
      
      const isLine = this.chartType === 'line'
      
      this.orderChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['订单数', '订单金额'],
          top: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: !isLine,
          data: this.chartData.dates
        },
        yAxis: [
          {
            type: 'value',
            name: '订单数',
            position: 'left'
          },
          {
            type: 'value',
            name: '订单金额',
            position: 'right',
            axisLabel: {
              formatter: '¥{value}'
            }
          }
        ],
        series: [
          {
            name: '订单数',
            type: this.chartType,
            data: this.chartData.orderCounts,
            smooth: isLine,
            itemStyle: {
              color: '#67C23A'
            }
          },
          {
            name: '订单金额',
            type: this.chartType,
            yAxisIndex: 1,
            data: this.chartData.orderAmounts,
            smooth: isLine,
            itemStyle: {
              color: '#F56C6C'
            }
          }
        ]
      }, true)
    },
    
    /** 加载运营商当日订单排行 */
    loadDistributorRank() {
      this.rankLoading = true
      const date = this.rankDate || dayjs().format('YYYY-MM-DD')
      const startTime = date + ' 00:00:00'
      const endTime = date + ' 23:59:59'
      this.$http.get('/dashboard/distributor-order-rank', {
        params: {
          startTime: startTime,
          endTime: endTime,
          queryDistributorId: this.queryDistributorId
        }
      }).then((res) => {
        if (res.data.code == 200) {
          this.distributorRankList = res.data.data || []
          this.rankMaxCount = this.distributorRankList.reduce((max, item) => {
            return Math.max(max, item.orderCount || 0)
          }, 1)
        } else {
          this.distributorRankList = []
          this.rankMaxCount = 1
        }
      }).catch(() => {
        this.distributorRankList = []
        this.rankMaxCount = 1
      }).finally(() => {
        this.rankLoading = false
      })
    },
    
    /** 初始化排行日期为今天 */
    initRankDate() {
      this.rankDate = dayjs().format('YYYY-MM-DD')
    },
    
    /** 跳转到完整榜单页 */
    goFullRank() {
      this.$router.push('/trip/distributorOrderRank')
    },
    
    /** 排名样式（前三名高亮） */
    getRankClass(index) {
      if (index === 0) return 'rank-no-1'
      if (index === 1) return 'rank-no-2'
      if (index === 2) return 'rank-no-3'
      return ''
    },
    
    /** 进度条宽度按订单数占比计算 */
    getBarStyle(orderCount) {
      const percent = this.rankMaxCount > 0 ? (orderCount / this.rankMaxCount) * 100 : 0
      return { width: percent + '%' }
    }
  }
}

</script>

<style scoped>
.dashboard-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 84px);
}

.dashboard-header {
  margin-bottom: 30px;
  text-align: center;
}

.welcome-title {
  font-size: 28px;
  color: #303133;
  margin-bottom: 10px;
  font-weight: 500;
}

.row-container {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.half-width {
  flex: 1;
  min-width: 0;
}

.section-wrapper {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
}

.section-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.date-picker {
  width: 450px;
}

.chart-buttons {
  display: flex;
  gap: 10px;
}

.stats-cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 10px;
}

.stats-card {
  background-color: #f5f7fa;
  border-radius: 8px;
  padding: 12px;
  min-width: 120px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stats-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-icon {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.card-icon i {
  font-size: 14px;
  color: white;
}

.card-info {
  flex: 1;
}

.card-title {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.card-value {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
}

.card-action {
  font-size: 11px;
  color: #409EFF;
  cursor: pointer;
  margin-top: 3px;
}

.card-action:hover {
  text-decoration: underline;
}

.chart-section {
  margin-bottom: 20px;
}

.chart-container {
  margin-top: 20px;
}

.action-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

/* 运营商订单排行样式 */
.rank-section {
  margin-bottom: 20px;
}

.rank-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
}

.rank-date-picker {
  width: 160px;
}

.rank-grid {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 8px;
  min-height: 60px;
}

.rank-empty {
  grid-column: 1 / -1;
  text-align: center;
  color: #909399;
  padding: 20px 0;
}

.rank-card {
  display: flex;
  align-items: stretch;
  gap: 6px;
  padding: 6px 8px;
  background-color: #f5f7fa;
  border-radius: 6px;
  border-left: 3px solid #c0c4cc;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.rank-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.rank-card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
}

.rank-no {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 50%;
  background-color: #c0c4cc;
  color: #fff;
  font-weight: bold;
  font-size: 11px;
  flex-shrink: 0;
  align-self: flex-start;
}

.rank-no-1 {
  background-color: #f56c6c;
}

.rank-no-2 {
  background-color: #e6a23c;
}

.rank-no-3 {
  background-color: #67c23a;
}

.rank-name {
  color: #303133;
  font-size: 12px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 4px;
}

.rank-bar-wrapper {
  height: 4px;
  background-color: #fff;
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 4px;
}

.rank-bar {
  height: 100%;
  background: linear-gradient(90deg, #409EFF, #67C23A);
  border-radius: 2px;
  transition: width 0.5s ease;
}

.rank-count {
  color: #606266;
  font-weight: 600;
  font-size: 12px;
  text-align: right;
}

@media (max-width: 1400px) {
  .rank-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (max-width: 992px) {
  .rank-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .rank-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.refresh-btn, .withdrawal-btn {
  border-radius: 20px;
  padding: 12px 25px;
  font-weight: 500;
}

.withdrawal-btn {
  background: linear-gradient(135deg, #67C23A, #85CE61);
  border: none;
}

@media (max-width: 768px) {
  .stats-cards-container {
    flex-direction: column;
  }
  
  .section-title-row {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
  
  .date-picker {
    width: 100%;
  }
  
  .chart-buttons {
    width: 100%;
    justify-content: flex-start;
  }
  
  .action-container {
    flex-direction: column;
    align-items: center;
  }
  
  .refresh-btn, .withdrawal-btn {
    width: 200px;
  }
}
</style>
